import { CUBE_AGGREGATE_INTERACTION, CUBE_INTERACTION_AGGREGATE_PRODUCT_MESSAGE } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';

const PRODUCT_MESSAGE_NAME_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.product_message_name`],
    limit: 5000,
    timeDimensions: [timeDimensions],
    order: {
      [`${sourceCube}.product_message_name`]: 'asc',
    },
  };
  return query;
};

const productMessageNameFilter: FilterConfigDynamic = {
  searchable: true,
  label: 'main.channelFocus.hcpCoverage.filters.productMessageName.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.productMessageName.placeholder',
  type: 'multiselect',
  clearable: true,
  getOptionsQuery: PRODUCT_MESSAGE_NAME_OPTIONS,
  sourceCube: CUBE_INTERACTION_AGGREGATE_PRODUCT_MESSAGE,
  mapResult: mapDimensionToOption(`${CUBE_INTERACTION_AGGREGATE_PRODUCT_MESSAGE}.product_message_name`),
  applyFilter: (value): Filter | undefined => {
    if (Array.isArray(value) && value.every(filterValue => typeof filterValue === 'string')) {
      return {
        member: `${CUBE_INTERACTION_AGGREGATE_PRODUCT_MESSAGE}.product_message_name`,
        operator: 'equals',
        values: value,
      };
    }
  },
  defaultValue: [],
};

export default productMessageNameFilter;
